/* Base styles (Mobile-first) */
import styled from 'styled-components'
import { IconMoon } from '@usap/widgets/src/components/MyAccount/OrderHistory/style/OrderHistory.css'

export const CarouselContainer = styled.div`
    width: 100%;
    display: flex;
    position: relative;
    align-items: stretch;
`
export const CarouselButton = styled.button`
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
    display: none;
    justify-content: center;
    align-items: center;
    background-color: rgba(40,40,50,1);
    cursor: pointer;
    z-index: 10;
    outline: 2px solid transparent;
    outline-offset: 2px;
    line-height: 1.375rem;
    font-weight: 600;
    font-size: .875rem;
    padding: 0;
    border-color: transparent;
    border-width: 1px;
    border-radius: 0.125rem;
    color: rgba(255,255,255,1) !important;

    &.carousel-left-button{
        left: 0.5rem;
        top: 83px;
    }

    &.carousel-right-button{
        right: 0.5rem;
        top: 83px;
    }

    &.disabled{
        color: #5E5E65 !important;
        background-color: rgba(244,244,244,1);
        cursor: not-allowed;
    }

    @media(min-width: 768px){
        display: flex; /* Show buttons on small screens */
        width: 2rem;
        height: 3rem;

        &.carousel-left-button{
            left: 0.25rem;
        }

        &.carousel-right-button{
            right: 0.25rem;
        }
    }

    @media (min-width: 1024px) {
        width: 2rem;
        height: 3rem;
        
        &.carousel-left-button{
            left: -2.25rem;
        }

        &.carousel-right-button{
            right: -2.25rem;
        }
    }
`

export const CarouselTrack = styled.div`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 0.5rem; 
    width: 100%;
    scrollbar-width: none;
    scrollbar-color: #ccc #f0f0f0;

    -webkit-scrollbar {
        display: none;
    }

    @media(min-width: 768px) {
        &.gap-md {
            gap: 1rem;
        }
    }
    
    @media (min-width: 1024px) {
        gap: 0px;
    }
`
export const CarouselTopRightControl = styled.div`
    position: absolute;
    top: -3rem;
    right: 0.5rem;
    display: flex;
    gap: 0.5rem;
`
export const CarouselIcon = styled(IconMoon)`
    width: 1.25rem;
    height: 1.25rem;
    fill: currentColor;
`

export const CarouselSmallIcon = styled(IconMoon)`
    width: 1.25rem;
    height: 1.25rem;
`